"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrandLogo = void 0;
var _logoModule = _interopRequireDefault(require("@albelli/arc-3/lib/logo.module.css"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _react = _interopRequireDefault(require("react"));
var _excluded = ["vendor", "href", "brand", "white", "small"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var brands = ["albelli", "bonusprint", "fotoknudsen", "minnebanken", "onskefoto", "monalbumphoto", "posterxxl", "posterxxl-b2b"];
var BrandLogo = function BrandLogo(_ref) {
  var _classnames;
  var vendor = _ref.vendor,
    href = _ref.href,
    brand = _ref.brand,
    white = _ref.white,
    small = _ref.small,
    props = _objectWithoutProperties(_ref, _excluded);
  var brandLookup = function brandLookup(vendor) {
    var brand = brands.find(function (i) {
      return vendor.toLowerCase().includes(i);
    });
    return brand ? brand : brands[0];
  };
  var isB2bBrand = false;
  if (!!vendor && !brand) {
    brand = brandLookup(vendor);
    isB2bBrand = vendor.toLowerCase().includes("b2b");
  }
  var brandLogoClass = "arc3-logo-".concat(brand + (isB2bBrand ? "-b2b" : ""));
  var classes = (0, _classnames2.default)(_logoModule.default[brandLogoClass], (_classnames = {}, _defineProperty(_classnames, _logoModule.default["white"], white), _defineProperty(_classnames, _logoModule.default["small"], small), _classnames));
  return /*#__PURE__*/_react.default.createElement("a", _extends({
    href: href
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: classes
  }));
};
exports.BrandLogo = BrandLogo;
BrandLogo.propTypes = {
  /** Which logo to set - alternative to brand, will attempt to match vendor to brand */
  vendor: _propTypes.PropTypes.string,
  /** Href to main site for navigation purposes */
  href: _propTypes.PropTypes.string,
  /** Which logo to set */
  brand: _propTypes.PropTypes.oneOf(brands),
  /** Set the colour to white */
  white: _propTypes.PropTypes.bool,
  /** Set the size to small */
  small: _propTypes.PropTypes.bool
};